import { For } from "solid-js";
import { OPEN_TO_FIELD, OPEN_TO_KEYS, OPEN_TO_LABELS, type OpenToFlags, type OpenToKey } from "~/lib/open-to";

type Props = {
  flags: OpenToFlags;
  onToggle: (key: OpenToKey) => void;
};

export function OpenToToggles(props: Props) {
  return (
    <fieldset class="open-to-fieldset">
      <legend>Open to</legend>
      <p class="muted">Shown as badges on your directory card and profile.</p>
      <For each={OPEN_TO_KEYS}>
        {(key) => (
          <label class="switch-row" style={{ "margin-top": "8px" }}>
            <span>{OPEN_TO_LABELS[key]}</span>
            <input
              type="checkbox"
              checked={!!props.flags[OPEN_TO_FIELD[key]]}
              aria-label={OPEN_TO_LABELS[key]}
              onChange={() => props.onToggle(key)}
            />
          </label>
        )}
      </For>
    </fieldset>
  );
}
